import { Nullable } from 'global';
import Delta from 'quill-delta';
import ReactQuill, { Quill } from 'react-quill';

export const checkIfQuillValueIsEmpty = (quillValue?: Delta | Nullable<string>) => {
  try {
    if (!quillValue) return true;

    const regex = /(<([^>]+)>)/gi;

    let htmlStringToCheck;

    if (typeof quillValue === 'string') {
      htmlStringToCheck = quillValue;
    } else {
      const tempQuill = new Quill(document.createElement('div'));
      // @ts-ignore
      tempQuill.setContents(quillValue);
      htmlStringToCheck = tempQuill.root.innerHTML?.replace(regex, '');
    }

    return !htmlStringToCheck.replace(regex, '').length;
  } catch (e) {
    return true;
  }
};

export const convertHtmlToDelta = (html: string): ReactQuill.Value => {
  if (!html) return '';

  let container: HTMLDivElement | null = null;

  try {
    container = document.createElement('div');
    container.innerHTML = html;

    const quill = new Quill(container);
    return quill.getContents();
  } catch (error) {
    console.error('HTML to Delta conversion failed:', error);
    return '';
  } finally {
    if (container) {
      container.innerHTML = '';
      container.remove();
    }
  }
};
